import React, { Fragment, FunctionComponent } from "react";
import EventPageProps from "./EventPageProps.interface";

import ContentPageBlock from "pages/ContentPage/ContentPage.block";

const EventPage: FunctionComponent<EventPageProps> = (props) => {
    return (
        <Fragment>
            {props.blocks?.map((blockContent, index) => {
                return (
                    <ContentPageBlock key={blockContent?.contentUdi} {...blockContent} />
                );
            })}
        </Fragment>
    );
};

export default EventPage;